import { render } from "./NavLayout.vue?vue&type=template&id=35404299&scoped=true&ts=true"
import script from "./NavLayout.vue?vue&type=script&lang=ts"
export * from "./NavLayout.vue?vue&type=script&lang=ts"

import "./NavLayout.vue?vue&type=style&index=0&id=35404299&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35404299"]])

export default __exports__